module.exports = __webpack_public_path__ + "static/media/ExchangeRate.272e5cd0.svg";